import { Request } from '@/core'
import { control } from '@/constants/urls'

export default {
  get: terminal =>
    Request.get(`${control.terminalQuotas}?unload_id=${terminal}`),
}
